<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Llama-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<div data-content-area="content" data-defined-in="Llama.ScanReceipt">
							<lowgile-image-selector
								class="has-imageUsed-handler"
								(imageUsed)="handler_ImageSelectorBlock_4_imageUsed_$adhoc_0($event, {  })"
								[allowFileSelection]="true"
								[allowedFileMimeTypes]="['image/*', 'application/pdf']"
								[allowCamera]="true"
								[autoStartCapturing]="false"
								[autoUseImage]="false"
								[requestedImageWidth]="2560"
								[requestedImageHeight]="undefined"
								mode="image"
								[takePictureOnQrDetection]="true"
								captureImageFormat="png"
							/>
						</div>
					</ng-template>
				</Llama-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
